module.exports = __webpack_public_path__ + "img/fail.90d78384.png";